import { render, staticRenderFns } from "./firstSupplierHistory.vue?vue&type=template&id=6b51cff9&scoped=true"
import script from "./firstSupplierHistory.vue?vue&type=script&lang=js"
export * from "./firstSupplierHistory.vue?vue&type=script&lang=js"
import style0 from "./firstSupplierHistory.vue?vue&type=style&index=0&id=6b51cff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b51cff9",
  null
  
)

export default component.exports